import "./style.scss";
import React, { useState, useEffect } from "react";
import Icon from "../../elements/icon";
import BodyText from "../../elements/body-text";
import { AccordionWrapper, Heading } from "../../elements";
import { useDispatch, useSelector } from "react-redux";
import { pdpBundleSelector, pdpDeliverySelector, pdpLccIdSelector, pdpLccSelector, pdpOrderPreviewSelector, pdpSummarySelector, pdpTouchPointSelector, pdpLoanOrderStatusSelector, pdpPlanTypeSelector } from "../../selectors/pdp";
import { setPdpOrderOreviewAction } from "../../redux/actions";
import api from "../../utils/api";
import { getPdpPlanType, isEmptyObject } from "../../utils/siteUtils";
import { orderTypes, PdpSpuType, ProductType } from "../../utils/lynkco-constants";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { MathUtils } from "../../utils";
import PdpOrderSummaryInfo from "../pdp-order-summary-info";
import { getSiteCountry } from "../../services/siteService";
import { setDisclaimer } from "../../services/pdpSummaryService";

const PdpOrderSummary = ({ fields, orderDetail }) => {
  /*Redux start*/
  const dispatch = useDispatch();
  const orderPreview = useSelector(pdpOrderPreviewSelector);
  const pdpSummary = useSelector(pdpSummarySelector);
  const pdpPlanType = useSelector(pdpPlanTypeSelector);
  const pdpDelivery = useSelector(pdpDeliverySelector);
  const pdpLccId = useSelector(pdpLccIdSelector);
  const pdpBundle = useSelector(pdpBundleSelector);
  const pdpTouchPoint = useSelector(pdpTouchPointSelector);
  const pdpLoanOrderStatus = useSelector(pdpLoanOrderStatusSelector);
  const setOrderPreview = payload => dispatch(setPdpOrderOreviewAction(payload));

  /*Redux end*/
  const {
    body,
    disclaimer,
    heading,
    headingType,
    servicePackageDisclaimer,
    wheelServiceDisclaimer,
    loanInterestRateUnit,
    loanPaymentMonthPeriodUnit,
    monthFeeValueUnit,
    finalPaymentNotSelectedValue,
    noValue,
    servicePackageFirstMonthFreeValue,
    servicePackageNotSelectedValue,
    servicePackageSelectedValue,
    wheelServiceNotSelectedValue,
    wheelServiceSelectedValue,
    yesValue
  } = fields;
  const { carTitle, deliveryCostInclTitle, deliveryTitle, dueTodayTitle, loanRequestTitle, membershipTitle, monthlyFeeInclTitle, priceInclTitle, servicesTitle } = fields;
  const {
    carPriceLabel,
    colorLabel,
    contractPeriodLabel,
    countryLabel,
    downPaymentLabel,
    deliveryLable,
    engineLabel,
    finalpaymentLabel,
    loanInstollmentLabel,
    loanAmountLabel,
    loanFinalpaymentLabel,
    methodLabel,
    mileageLabel,
    modelLabel,
    planLabel,
    servicePackageLabel,
    serviceFeeLabel,
    towbarLabel,
    wheelsLabel,
    wheelsServiceLabel,
    footnoteSymbol
  } = fields;
  const lang = webStorage.get(S_LANG);
  const [total, setTotal] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [orderPreviewLocal, setOrderPreviewLocal] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [featureList, setFeatureList] = useState([]);
  useEffect(() => {
    init();
  }, [pdpSummary, pdpDelivery, pdpTouchPoint]);
  useEffect(() => {
    getCountries();
  }, [orderDetail]);
  useEffect(() => {
    setSummaryValue();
  }, [orderPreviewLocal]);
  useEffect(() => {
    // setLoanCashPriceList();
    if (!isEmptyObject(orderPreview)) {
      setOrderPreviewLocal(orderPreview);
    }
    if (!isEmptyObject(orderDetail)) {
      setOrderPreviewLocal(orderDetail);
    }
  }, [orderDetail, orderPreview]);
  const setYesOrNo = value => {
    let newValue = value === "1" ? yesValue?.value : noValue?.value;
    return newValue;
  };
  const init = async () => {
    if (!isEmptyObject(pdpSummary) && pdpSummary.apiBody?.skuQtyVoList?.length) {
      let skuQtyVoList = [...(pdpSummary?.apiBody?.skuQtyVoList || [])];
      const orderExtraData = {
        ...(pdpSummary?.apiBody?.orderExtraData || {}),
        lccId: pdpLccId,
        carDeliveryMethod: pdpDelivery?.value
      };
      if (pdpDelivery?.value === "home delivery" && !skuQtyVoList.some(x => x.skuId === pdpBundle?.delivery?.skuId)) {
        skuQtyVoList.push({
          skuId: pdpBundle?.delivery?.skuId,
          qty: 1
        });
      } else {
        Object.assign(orderExtraData, {
          mccId: pdpTouchPoint?.parentId,
          touchPointId: pdpTouchPoint?.id
        });
      }
      const reqBody = {
        // bundleId: "string",
        // orderExtraData: {
        //   lccId: 0,
        //   mccId: 0,
        //   touchPointId: 0,
        //   carDeliveryMethod: "",
        //   loanTotalAmount: "",
        //   loanMonthlyFee: "",
        //   loanDownPayment: "",
        //   loanInterestRate: "",
        //   loanPaymentMonthPeriod: ""
        // },
        // "promotions": [
        //   {
        //     "promotionId": 0,
        //     "promotionType": "string"
        //   }
        // ],
        // deliveryId: "string",
        // skuQtyVoList: [
        //   {
        //     qty: 0,
        //     skuId: 0
        //   }
        // ],
        // subType: "string",
        // deliveryStoreCode: "string"
        ...pdpSummary?.apiBody,
        // bundleId: pdpSummary?.apiBody?.bundleId,
        orderExtraData,
        skuQtyVoList,
        productType: ProductType.vehicle
      };
      const res = await api.vehicle.order.preview(null, reqBody);
      setOrderPreview(res.obj);
    }
  };
  const getCountries = async () => {
    let newlang = lang;
    if (orderDetail) {
      newlang = orderDetail?.country ? `${orderDetail?.language?.toLowerCase()}-${orderDetail?.country?.toLowerCase()}` : orderDetail?.language?.toLowerCase();
    }
    const country = await getSiteCountry(newlang);
    setCountryData(country?.name);
  };
  const getServicePackageFirstMonth = () => {
    let orderItems = !isEmptyObject(orderDetail) ? orderPreviewLocal?.suborders[0]?.orderItems || [] : orderPreviewLocal?.orderItems || [];
    let isFirstMonthItem = orderItems.filter(item => item?.tag === PdpSpuType?.servicePackage);
    let isFirstMonth = isFirstMonthItem?.length ? isFirstMonthItem[0]?.bonusPeriod > 0 : null;
    return isFirstMonth;
  };
  const setSummaryValue = () => {
    if (!orderPreviewLocal?.orderExtraData) return null;
    switch (orderPreviewLocal?.subType) {
      case orderTypes.monthToMonth:
        setM2mValue();
        break;
      case orderTypes.buyACarLoan:
      case orderTypes.buyACarCash:
        setLoanCashPriceList();
        break;
      default:
        break;
    }
  };
  const setM2mValue = () => {
    const { carDeliveryMethod, color, engine, model, planName, totalMonthlyFee, towbarFee, deliveryFee } = orderPreviewLocal?.orderExtraData;
    const { isWithTowbar } = orderPreviewLocal?.orderExtraData;
    const isServicePackageFirstMonthFree = getServicePackageFirstMonth();
    // let wheelServiceDisclaimer = setWheelServiceDisclaimer();
    const { carePlanDisclaimer } = setDisclaimer(orderPreviewLocal);
    let monthyFeeBreakDown = [
      { title: towbarLabel?.value, value: MathUtils.priceFormat(towbarFee ? towbarFee : 0, lang) },
      { title: `${servicePackageLabel?.value} ${isServicePackageFirstMonthFree ? servicePackageFirstMonthFreeValue?.value : ""}`, value: servicePackageSelectedValue.value, disclaimer: `<p style="color: rgb(150, 150, 150);">${carePlanDisclaimer}</p>` }
    ];
    // if (wheelsServiceLabel?.value) {
    // monthyFeeBreakDown.push({ title: wheelsServiceLabel?.value, value: wheelServiceSelectedValue.value, disclaimer: `<p style="color: rgb(150, 150, 150);">${wheelServiceDisclaimer}</p>` });
    // }
    let newPriceList = [
      {
        title: monthlyFeeInclTitle?.value,
        value: `${MathUtils.priceFormat(totalMonthlyFee, lang)}${monthFeeValueUnit?.value}`,
        items: monthyFeeBreakDown
      }
    ];
    let deliveryCostInclProp = {
      title: deliveryCostInclTitle?.value,
      value: `${MathUtils.priceFormat(deliveryFee, lang)}`,
      items: [{ title: carDeliveryMethod, value: MathUtils.priceFormat(deliveryFee || 0, lang) }]
    };
    if (carDeliveryMethod) {
      newPriceList.unshift(deliveryCostInclProp);
    }
    setPriceList(newPriceList);
    setFeatureList([
      {
        heading: membershipTitle?.value,
        items: [
          { title: countryLabel?.value, value: countryData },
          { title: planLabel?.value, value: planName }
        ]
      },
      {
        heading: carTitle?.value,
        items: [
          { title: modelLabel?.value, value: model },
          { title: colorLabel?.value, value: color },
          { title: engineLabel?.value, value: engine },
          { title: towbarLabel?.value, value: setYesOrNo(isWithTowbar) }
        ]
      },
      {
        heading: deliveryTitle?.value,
        items: [{ title: methodLabel?.value, value: pdpDelivery?.label || carDeliveryMethod }]
      }
    ]);
  };
  const setLoanCashPriceList = async () => {
    const {
      carDeliveryMethod,
      carFee,
      color,
      deliveryFee,
      dueTodayFee,
      engine,
      finalPayment,
      lccId,
      loanDownPayment,
      loanFinalPayment,
      loanInterestRate,
      loanMonthlyFee,
      loanPaymentMonthPeriod,
      loanTotalAmount,
      model,
      planName,
      reservationFee,
      servicePackageFee,
      servicePackageVariant,
      totalMonthlyFee,
      towbarFee,
      wheelServiceFee,
      winterWheelsFee,
      winterWheelsVariant
    } = orderPreviewLocal?.orderExtraData;
    const { isCarWheelService, isWithServicePackage, isWithTowbar, isWithWinterWheels } = orderPreviewLocal?.orderExtraData;
    const { wheelServiceDisclaimer, carePlanDisclaimer } = setDisclaimer(orderPreviewLocal);
    const isServicePackageFirstMonthFree = getServicePackageFirstMonth();
    let newPriceList = [],
      servicesTitleProp = [{ title: servicePackageLabel?.value, value: servicePackageVariant || setYesOrNo(isWithServicePackage) }],
      newTotal = [];
    let loanRequest = orderPreviewLocal?.detailedOrderStatus || pdpLoanOrderStatus ? true : false;
    /*monthyFee*/
    let monthyFeeBreakDown = [{ title: `${servicePackageLabel?.value} ${isServicePackageFirstMonthFree ? servicePackageFirstMonthFreeValue?.value : ""}`, value: MathUtils.priceFormat(servicePackageFee || 0, lang), disclaimer: `<p style="color: rgb(150, 150, 150);">${carePlanDisclaimer}</p>` }];
    if (wheelsServiceLabel?.value && isCarWheelService === "1") {
      monthyFeeBreakDown.unshift({ title: wheelsServiceLabel?.value, value: MathUtils.priceFormat(wheelServiceFee || 0, lang), disclaimer: `<p style="color: rgb(150, 150, 150);">${wheelServiceDisclaimer}</p>` });
    }
    if (isWithServicePackage === "0" || servicePackageVariant === "Unlimited") {
      servicesTitleProp.pop();
      monthyFeeBreakDown.pop();
    }
    let monthlyFeeInclTitleProp = {
      title: monthlyFeeInclTitle?.value,
      value: `${MathUtils.priceFormat(totalMonthlyFee, lang)}${monthFeeValueUnit?.value}`,
      items: monthyFeeBreakDown
    };
    /*monthyFee*/
    // let finalpaymentDisclaimer = `${engine ? `${engine}:` : ""}${MathUtils.priceFormat(carFee, lang)}, ${towbarLabel?.value}:${MathUtils.priceFormat(towbarFee || 0, lang)}, ${wheelsLabel?.value}:${MathUtils.priceFormat(winterWheelsFee || 0, lang)}`;
    let finalpaymentDisclaimer = `${engine ? `${engine}:` : ""}${MathUtils.priceFormat(carFee, lang)}, ${towbarLabel?.value}:${MathUtils.priceFormat(towbarFee || 0, lang)}`;
    let loanInstollmentDisclaimer = "";
    if (lang === "it-it") {
      loanInstollmentDisclaimer = `${pdpSummary.effectiveInterestLabel?.trim()}, `;
    }
    loanInstollmentDisclaimer = `${loanInstollmentDisclaimer}${MathUtils.percentFormat(loanInterestRate, lang)}${loanInterestRateUnit?.value}, ${loanPaymentMonthPeriod}${loanPaymentMonthPeriodUnit?.value} ${
      loanFinalPayment ? `${MathUtils.priceFormat(loanFinalPayment || 0, lang)} ${loanFinalpaymentLabel?.value}` : `,${finalPaymentNotSelectedValue?.value}`
    }`;
    let dueTodayProp = {
      title: dueTodayTitle?.value,
      value: MathUtils.priceFormat(dueTodayFee + deliveryFee, lang),
      items: [
        { title: serviceFeeLabel?.value, value: MathUtils.priceFormat(dueTodayFee, lang) },
        { title: deliveryLable?.value, value: MathUtils.priceFormat(deliveryFee, lang) }
      ]
    };
    let loanRequestProp = {
      title: loanRequestTitle?.value,
      value: MathUtils.priceFormat(loanTotalAmount, lang),
      items: [
        { title: downPaymentLabel?.value, value: MathUtils.priceFormat(loanDownPayment, lang) },
        { title: loanInstollmentLabel?.value, value: MathUtils.priceFormat(loanMonthlyFee, lang), disclaimer: `<p style="color: rgb(150, 150, 150);">${loanInstollmentDisclaimer}</p>`, footnote: footnoteSymbol?.value }
      ]
    };
    if (orderPreviewLocal?.subType === orderTypes.buyACarLoan) {
      // newTotal = {
      //   title: monthlyFeeInclTitle?.value,
      //   value: "$100.00"
      // };
      if (loanRequest) {
        finalpaymentDisclaimer += `${downPaymentLabel?.value}:${MathUtils.priceFormat(loanDownPayment, lang)}, ${loanAmountLabel?.value}:${MathUtils.priceFormat(loanTotalAmount, lang)}`;
      }
      newPriceList = [
        {
          title: priceInclTitle?.value,
          value: MathUtils.priceFormat(finalPayment, lang),
          items: [
            {
              title: carPriceLabel?.value,
              value: MathUtils.priceFormat(finalPayment, lang),
              disclaimer: `<p style="color: rgb(150, 150, 150);">${finalpaymentDisclaimer}</p>`
            }
          ]
        }
      ];
      if (monthyFeeBreakDown?.length) {
        newPriceList.push(monthlyFeeInclTitleProp);
      }
      if (loanRequest) {
        newPriceList.push(dueTodayProp);
      } else {
        newPriceList.push(loanRequestProp);
      }
    } else if (orderPreviewLocal?.subType === orderTypes.buyACarCash) {
      newPriceList = [
        {
          title: priceInclTitle?.value,
          value: MathUtils.priceFormat(finalPayment, lang),
          items: [
            {
              title: finalpaymentLabel?.value,
              value: MathUtils.priceFormat(finalPayment, lang),
              disclaimer: `<p style="color: rgb(150, 150, 150);">${finalpaymentDisclaimer}</p>`
            }
          ]
        },
        dueTodayProp
      ];
      if (monthyFeeBreakDown?.length) {
        newPriceList.splice(1, 0, monthlyFeeInclTitleProp);
      }
    }
    if (wheelsServiceLabel?.value) {
      servicesTitleProp.unshift({ title: wheelsServiceLabel?.value, value: setYesOrNo(isCarWheelService) });
    }
    setTotal(newTotal);
    setPriceList(newPriceList);
    if (servicesTitleProp.length === 0) {
      setFeatureList([
        {
          heading: membershipTitle?.value,
          items: [
            { title: countryLabel?.value, value: countryData },
            { title: planLabel?.value, value: planName }
          ]
        },
        {
          heading: carTitle?.value,
          items: [
            { title: modelLabel?.value, value: model },
            { title: colorLabel?.value, value: color },
            { title: engineLabel?.value, value: engine },
            { title: towbarLabel?.value, value: setYesOrNo(isWithTowbar) }
            // { title: wheelsLabel?.value, value: winterWheelsVariant || setYesOrNo(winterWheelsVariant) }
          ]
        },
        {
          heading: deliveryTitle?.value,
          items: [{ title: methodLabel?.value, value: pdpDelivery?.label || carDeliveryMethod }]
        }
      ]);
    } else {
      setFeatureList([
        {
          heading: membershipTitle?.value,
          items: [
            { title: countryLabel?.value, value: countryData },
            { title: planLabel?.value, value: planName }
          ]
        },
        {
          heading: carTitle?.value,
          items: [
            { title: modelLabel?.value, value: model },
            { title: colorLabel?.value, value: color },
            { title: engineLabel?.value, value: engine },
            { title: towbarLabel?.value, value: setYesOrNo(isWithTowbar) }
            // { title: wheelsLabel?.value, value: winterWheelsVariant || setYesOrNo(winterWheelsVariant) }
          ]
        },
        {
          heading: servicesTitle?.value,
          items: servicesTitleProp
        },
        {
          heading: deliveryTitle?.value,
          items: [{ title: methodLabel?.value, value: pdpDelivery?.label || carDeliveryMethod }]
        }
      ]);
    }
  };

  const itemList = null;
  const accordionProps = {
    heading: {
      html: { ...heading },
      type: headingType,
      typographyClass: "type-link"
    }
  };
  const pdpOrderSummaryInfoProps = {
    fields,
    loanTermsAndConditions: pdpSummary?.loanTermsAndConditions,
    itemList,
    featureList,
    total,
    priceList
  };

  const disclaimerValue = pdpPlanType || getPdpPlanType(orderPreviewLocal?.subType);
  return (
    <div className="pdp-order-summary">
      <div className="summary-container-mobile">
        <AccordionWrapper {...accordionProps}>
          <PdpOrderSummaryInfo {...pdpOrderSummaryInfoProps} disclaimerValue={disclaimerValue} />
        </AccordionWrapper>
      </div>
      <div className="summary-container-desktop">
        <div className="heading-container">
          <div className="heading-content">
            <Icon name="Cart" size="s" />
            <Heading type={headingType} html={{ ...heading }} typographyClass="type-h3" />
            <BodyText html={body} className="caption" />
          </div>
        </div>
        <PdpOrderSummaryInfo {...pdpOrderSummaryInfoProps} disclaimerValue={disclaimerValue} />
      </div>
    </div>
  );
};

export default PdpOrderSummary;
